import { render, staticRenderFns } from "./CheckoutPricesTable.vue?vue&type=template&id=287b8af0"
import script from "./CheckoutPricesTable.vue?vue&type=script&lang=js"
export * from "./CheckoutPricesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports